import { useMemo } from "react";
import { DataTable } from "@/components/ui/data-table";
import type { CreanceRow } from "@/lib/creance.api";
import { createCreanceColumns } from "../creanceTableColumns";

interface CreancesTableProps {
  rows: CreanceRow[];
  loading: boolean;
  onSelect: (row: CreanceRow) => void;
}

export function CreancesTable({ rows, loading, onSelect }: CreancesTableProps) {
  const columns = useMemo(() => createCreanceColumns(onSelect), [onSelect]);

  return (
    <DataTable
      columns={columns}
      data={rows}
      loading={loading}
      emptyMessage="Aucune créance."
      onRowClick={onSelect}
      pageSize={10}
    />
  );
}
